export class Message {

    public ServerMsgID: number;
    public ClientMsgID: number;
    public RecipientType: RecipientType;
    public RecipientID: string;
    public SenderID: string;
    public SalesmanameE: string;
    public SalesmanNameA: string;

    public Content: string;
    public ContentType: ContentType;
    public MsgDateTime: Date;
    public Status: AllMessageStatus;
    public FullStatus: MessageStatus;
    public FullStatusTime: Date;

}
export class AllMessageStatus {
    public SentList: { [id: string]: Date; } = {};
    public DeliveredList: { [id: string]: Date; } = {};
    public ReadList: { [id: string]: Date; } = {};
}
export enum RecipientType {
    OneToOne = 0,
    Group=1
}

export enum ContentType {
    Text = 0,
    image,
    Video,
    VoiceNote,
    Location,
    Document // (word, excel and PDF )
}
export enum MessageStatus {
    Pending = 0,//(not used)
    sent,
    Delivered,
    Read
}

